module.exports = __webpack_public_path__ + "static/trig_002-b069c8f3490d89a5dc65204ac7ba3d84.webp";